// Add data types to window.navigator for use in this file. See https://www.typescriptlang.org/docs/handbook/triple-slash-directives.html#-reference-types- for more info.
/// <reference types="user-agent-data-types" />

import { ResourceAttributes } from '@opentelemetry/resources'

// https://opentelemetry.io/docs/specs/otel/resource/semantic_conventions/browser/

/**
 * This TypeScript function retrieves user agent data including browser brands, platform, mobile
 * status, language, and original user agent string.
 * @returns The function `getUserAgentData` returns an object of type `ResourceAttributes` which
 * contains information about the user agent, including the browser brands, platform, mobile status,
 * language, and the original user agent string.
 */
export const getUserAgentData = (): ResourceAttributes => {
  const attributes: ResourceAttributes = {}
  attributes['browser.brands'] = window.navigator.userAgentData?.brands.map((e) => `${e.brand} / ${e.version}`)
  attributes['browser.platform'] = window.navigator.userAgentData?.platform
  attributes['browser.mobile'] = window.navigator.userAgentData?.mobile
  attributes['browser.language'] = window.navigator.language
  attributes['user_agent.original'] = window.navigator.userAgent
  return attributes
}
